import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';

import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

import { getMessage } from "CONFIG/i18n";

import { getBootstrapTableOptions } from "UTILS/Utility";

import { formatDateByLocale, getTimeInLocaleTimezone } from "UTILS/DateUtils";

import ic_edit from "ASSETS/Images/qr_icons/ic_edit.webp";
import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";

import "./SystemAnnouncements.less";

export default class SystemAnnouncementList extends Component {

  constructor(props) {
    super(props)
  }

  handleChange = (announcement) => {
    let data = Object.assign(
      {},
      {
        id: announcement.id,
        title: announcement.title,
        message: announcement.message,
        activateFrom: announcement.activateFrom,
        activateTill: announcement.activateTill,
        agentScreen: announcement.agentScreen,
        userURL: announcement.userURL,
        userPasscode: announcement.userPasscode,
        userQRCode: announcement.userQRCode,
        isActive: !announcement.isActive
      }
    );
    this.props.editAnnouncement(data, error => {
      if(error) {
        console.error(error);
        toastr.error(getMessage(error.code))
      }
    })
  }

  activeAnnouncement = (cell, row) => {
    return (
      <Switch
        switchOn={row.isActive}
        toggleSwitch={() => this.handleChange(row)}
      />
    )
  }

  actionsFormat = (cell, row) => {
    return (
      <React.Fragment>
        <img
          src={ic_edit}
          className="mr-3 cursorPointer"
          onClick={(e) => {
            e.stopPropagation();
            this.props.showAddAnnouncementModal(true, row)
          }}
        />
        <img
          src={ic_delete}
          className="cursorPointer"
          onClick={e => {
            e.stopPropagation();
            console.log('[AnnouncementTable] Actions row.id: ', row.id);
            this.props.showDeleteAnnouncementConfirmationModal(true, row.id);
          }}
        />
      </React.Fragment>
    )
  }

  activateTillFormat = (cell, row) => {
    return(
      <div className="nameEllipsis">
        {formatDateByLocale(row.activateTill, this.props.language)} &nbsp;
        {getTimeInLocaleTimezone(row.activateTill)}
      </div>
    )
  }

  activateFromFormat = (cell, row) => {
    return(
      <div className="nameEllipsis">
        {formatDateByLocale(row.activateFrom, this.props.language)} &nbsp;
        {getTimeInLocaleTimezone(row.activateFrom)}
      </div>
    )
  }

  titleFormat = (cell, row) => {
    return (
      <span className="nameEllipsis mb-0" title={row.title}>
        {row.title}
      </span>
    )
  }

  messageFormat = (cell, row) => {
    return (
      <span className="nameEllipsis mb-0" title={row.message}>
        {row.message}
      </span>
    )
  }

  render() {
    return (
      <div className="systemAnnouncements">
        <BootstrapTable
          data={this.props.announcements}
          tableHeaderClass="tableHeader"
          tableBodyClass='tableBody'
          containerClass='organisationsList'
          bordered={false}
          options={getBootstrapTableOptions()}
        >
          <TableHeaderColumn
            dataField='id'
            hidden={true}
            isKey
          >
            {getMessage("id")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='title'
            dataFormat={this.titleFormat}
            columnClassName='nameEllipsis'
            width="17%"
            // dataSort={true}
            dataAlign='center'
          >
            {getMessage("TITLE")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='message'
            dataFormat={this.messageFormat}
            columnClassName='nameEllipsis'
            width="31%"
            // dataSort={true}
            headerAlign='center'
            dataAlign='left'
          >
            {getMessage("MESSAGE")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='activate_from'
            dataFormat={this.activateFromFormat}
            width="16%"
            // dataSort={true}
            dataAlign='center'
          >
            {getMessage("ACTIVATE_FROM")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='activateTill'
            dataFormat={this.activateTillFormat}
            width="16%"
            // dataSort={true}
            dataAlign='center'
          >
            {getMessage("ACTIVATE_TILL")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={this.activeAnnouncement}
            dataField='isActive'
            width="10%"
            // dataSort={true}
            dataAlign='center'
          >
            {getMessage("STATUS")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={this.actionsFormat}
            width="10%"
            // dataSort={true}
            dataAlign='center'
          >
            {getMessage("ACTIONS")}
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    )
  }
}